/**
   Copyright (c)2021 3Key Company s.r.o., All Rights Reserved

   It is strictly prohibited to distribute the source code,
   transpiled and compiled code or its parts without previous
   agreement of the 3Key Company board.
*/

import "./ProductFilterList.css";

import React from "react";

import { bindActionCreators, Dispatch } from "@reduxjs/toolkit";
import { connect } from "react-redux";

import { SelectedAssetFiltersState as RSelectedAssetFiltersState, slice } from "store/company/selectedAssetFilters.slice";
import { ProductFilterListProps, ProductFilterListState } from "./ProductFilterList.types";

import ColumnGrid from "components/ThreeKey/ColumnGrid";


class ProductFilterList extends React.Component<ProductFilterListProps, ProductFilterListState> {

   public render(): React.ReactNode {

      const vendorProductStringFix = (vps: string): string => {
         return vps.replaceAll("_", " ").replace(/\w\S*/g, m => m.charAt(0).toUpperCase() + m.substr(1).toLocaleLowerCase()) ;
      }

      const descs = this.props.selectedAssetFilters.filterDescs[this.props.filter.id];

      const filterDescs: any[] = descs ? [
         { label: "Part", items: descs.map(data => { if (data.field === "part") return { id: data.id, data: `${data.value}` }; else return null; }) || [] },
         { label: "Version", items: descs.map(data => { if (data.field === "version") return { id: data.id, data: `${data.value}` }; else return null; }) || [] },
         { label: "Update", items: descs.map(data => { if (data.field === "update") return { id: data.id, data: `${data.value}` }; else return null; }) || [] },
         { label: "Edition", items: descs.map(data => { if (data.field === "edition") return { id: data.id, data: `${data.value}` }; else return null; }) || [] },
         { label: "Language", items: descs.map(data => { if (data.field === "language") return { id: data.id, data: `${data.value}` }; else return null; }) || [] },
         { label: "SW edition", items: descs.map(data => { if (data.field === "sw_edition") return { id: data.id, data: `${data.value}` }; else return null; }) || [] },
         { label: "Target SW", items: descs.map(data => { if (data.field === "target_sw") return { id: data.id, data: `${data.value}` }; else return null; }) || [] },
         { label: "Target HW", items: descs.map(data => { if (data.field === "target_hw") return { id: data.id, data: `${data.value}` }; else return null; }) || [] },
         { label: "Other", items: descs.map(data => { if (data.field === "other") return { id: data.id, data: `${data.value}` }; else return null; }) || [] }
      ] : [];

      let totalItems = 0;
      filterDescs.forEach(fs => totalItems += fs.items.length)

      const columnGrid = totalItems > 0 ?
         <ColumnGrid
            columns={filterDescs}
            selectableItems={true}
            onItemDblClick={ (index, itemId) => { this.onRemoveFilterItem(this.props.filter.id, itemId) }}
            onCrossIconClick={ (index, itemId) => { this.onRemoveFilterItem(this.props.filter.id, itemId) }}
            crossIcon={true}
         />
      :
         <></>

      const isLoading =
         this.props.selectedAssetFilters.filterDescsLoading[this.props.filter.id] ||
         this.props.selectedAssetFilters.assetFilterDescCreating[this.props.filter.id] ||
         this.props.selectedAssetFilters.assetFilterDescDeleting[this.props.filter.id]

      return (

         <div className="product-filter-list-component-default" data-selected={this.props.filter.id === this.props.selectedAssetFilters.selectedFilter?.id}>
            <div className="remove-container"><div className="remove" onClick={(e) => this.onRemoveProductFilterClick(this.props.filter.id)}></div></div>
            <div className="spinner" data-visible={isLoading}></div>
            <div className="caption" onClick={(e) => this.onFilterLabelClick(this.props.filter.id)}><strong>{vendorProductStringFix(this.props.filter.vendor)}</strong> {vendorProductStringFix(this.props.filter.product)}</div>
            <div className="container">
               {columnGrid}
            </div>
         </div>

      )

   }

   private onFilterLabelClick = (filterId: string) => {
      this.props.actions.selectAssetFilter({ filterId });
   }

   private onRemoveProductFilterClick = (filterId: string) => {
      this.props.actions.deleteAssetFilterById({ filterId });
   }

   private onRemoveFilterItem = (filterId: string, id: string) => {
      this.props.actions.deleteAssetFilterDescById({ filterId, id });
   }

}

const mapStateToProps = (state: {
   selectedAssetFilters: RSelectedAssetFiltersState,
}) => {
   return state;
}


const mapDispatchToProps = (dispatch: Dispatch) => {

   return {
      actions: bindActionCreators(
         Object.assign(
            {},
            slice.actions
         ),
         dispatch
      )
   }

}

export default connect(
   mapStateToProps,
   mapDispatchToProps
)(ProductFilterList);
